import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Box, Divider, IconButton, Typography } from "@mui/material";

import { ServiceTypeEnum } from "../../../GoService/enum/service.enum";
import { useUserServicesPaginated } from "../../../GoService/api/queries/useUserServices";

import { AllServicesBackButtonIcon } from "../../assets/icons/services";

import AllServicesFilter from "./AllServicesFilter";
import AllServicesTypes from "./AllServicesTypes";
import ServicesList from "./ServicesList";
import ServicesPagination from "./ServicesPagination";

const SERVICE_LIMIT = 6;

const AllServices = () => {
  const { t } = useTranslation("profiles", {
    keyPrefix: "allServices",
  });

  const navigate = useNavigate();
  const { persona, id } = useParams();
  const [searchParams] = useSearchParams();
  const entityUserId = searchParams.get("userId");

  const handleBack = () => {
    // navigate(`/${persona}/${id}?tab=goService`);
    navigate(-1);
  };

  const ID = entityUserId || id;

  const page = Number(searchParams.get("page") || "1");
  const type = searchParams.get("type") as ServiceTypeEnum;

  const {
    data,
    isLoading: isUserServicesLoading,
    isError: isUserServicesError,
  } = useUserServicesPaginated({
    userId: Number(ID),
    limit: SERVICE_LIMIT,
    page: page - 1,
    type,
  });

  const services = data?.items;
  const meta = data?.meta;

  return (
    <Box sx={styles.root}>
      <Typography sx={styles.title}>
        <IconButton size="small" onClick={handleBack}>
          <AllServicesBackButtonIcon />
        </IconButton>
        {t("upgradeJoinerFootballSkills")}
      </Typography>
      <AllServicesTypes isDataLoading={isUserServicesLoading} />
      {/* <AllServicesFilter isDataLoading={isUserServicesLoading} /> */}
      <ServicesList services={services} isDataLoading={isUserServicesLoading} meta={meta} />
      {meta && meta.totalPages > 1 && (
        <>
          <Divider sx={styles.divider} orientation="horizontal" />
          <ServicesPagination totalPages={meta.totalPages} />
        </>
      )}
    </Box>
  );
};

export default AllServices;

const styles = {
  root: {
    width: "100%",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "var(--White, #FFF)",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
  },
  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: 800,
    lineHeight: "normal",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  divider: {
    borderColor: "#EAECF0",
    margin: "0 -20px",
  },
};
